export default __webpack_public_path__ + "static/media/rusgo-screenshot-06.c3a39cf0.png";